import { render, staticRenderFns } from "./app-detail-bk-module.vue?vue&type=template&id=13b97052&"
import script from "./app-detail-bk-module.vue?vue&type=script&lang=js&"
export * from "./app-detail-bk-module.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-bk-module.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports